import { fnv1a32 } from "../../../shared/hashing/fnv1a";

/** A repeatable stream of choices: the same seed always gives the same answers. */
export interface SeededRandom {
  /** A number in [low, high). */
  between(low: number, high: number): number;
  pick<T>(items: readonly T[]): T;
}

/** Mulberry32 over the seed's FNV-1a hash. */
export function seededRandom(seed: string): SeededRandom {
  let state = fnv1a32(seed);
  const next = (): number => {
    state = (state + 0x6d2b79f5) >>> 0;
    let mixed = Math.imul(state ^ (state >>> 15), state | 1);
    mixed ^= mixed + Math.imul(mixed ^ (mixed >>> 7), mixed | 61);
    return ((mixed ^ (mixed >>> 14)) >>> 0) / 0x100000000;
  };
  return {
    between: (low, high) => low + next() * (high - low),
    pick: (items) => {
      const item = items[Math.floor(next() * items.length)];
      if (item === undefined) {
        throw new Error("Nothing to pick from.");
      }
      return item;
    },
  };
}
